function loadStylesheet(url) {
  return new Promise(function (resolve, reject) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.onload = function () {
      resolve();
    };
    link.onerror = function () {
      reject();
    };
    document.head.appendChild(link);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  // loadStylesheet("/style/style_heart.min.css")
  //   // .then(function () {
  //   //   return loadStylesheet("/assets/vendor/fontawesome_6_2_1.min.css");
  //   // })
  //   .then(function () {
  //     // Stylesheets loaded successfully
  //   })
  //   .catch(function () {
  //     // Error loading stylesheets
  //   });

  // $("#loader_wrapper").fadeOut("fast");

  $('.delete').on('click', e => {
    e.preventDefault();
  });

  if (typeof Swiper !== 'undefined') {
    function initializeSwiper(selector, effect, delay) {
      return new Swiper(selector, {
        loop: true,
        effect: effect,
        autoplay: {
          delay: delay,
        },
        navigation: {
          nextEl: `${selector} .swiper-button-next`,
          prevEl: `${selector} .swiper-button-prev`,
        },
        pagination: {
          el: '.swiper-pagination',
        },
      });
    }

    initializeSwiper('.swiper', 'fade', 3000);
    initializeSwiper('.swiper2', 'fade', 6000);
    initializeSwiper('.swiper3', 'fade', 8000);
    initializeSwiper('.swiper5', 'slide', 5000);
  }

  // feather.replace();

  const bottom_navigation_item = $('#mobile-navigation .nav-item');

  bottom_navigation_item.on('click', function () {
    bottom_navigation_item.removeClass('active');
    $(this).addClass('active');
  });
});
